import type { H3Event } from "h3";
import { DOMAIN_BELLA_SICILIA, STORE_ID_BELLA_SICILIA, STORE_ID_ROESELARE, STORE_ID_TIENEN } from "~~/shared/utils/stores";

export function isBellaSicilia(loggedIn: boolean, storeId?: number): boolean {
  if (loggedIn) {
    return isBellaSiciliaByStore(storeId);
  }
  else {
    return isBellaSiciliaByDomain();
  }
}

export function isBellaSiciliaByDomain(): boolean {
  const requestUrl = useRequestURL();
  return requestUrl.origin.includes(DOMAIN_BELLA_SICILIA);
}

export function isBellaSiciliaByEvent(event: H3Event): boolean {
  const requestUrl = getRequestURL(event);
  return requestUrl.origin.includes(DOMAIN_BELLA_SICILIA);
}

export function isBellaSiciliaByStore(storeId?: number): boolean {
  return storeId === STORE_ID_BELLA_SICILIA;
}

export function isRoeselareByStore(storeId?: number): boolean {
  return storeId === STORE_ID_ROESELARE;
}

export function isTienenByStore(storeId?: number): boolean {
  return storeId === STORE_ID_TIENEN;
}
